import { NgModule } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { TreeComponent } from './components';
import {
  NgbAccordionBody,
  NgbAccordionButton, NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { WidgetHelpComponent } from '@pt/help';

@NgModule({
  declarations: [TreeComponent],
  imports: [
    NgbAccordionDirective,
    NgForOf,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionButton,
    FormsModule,
    NgbAccordionCollapse,
    NgbAccordionBody,
    WidgetHelpComponent,
    NgIf
  ],
  exports: [TreeComponent]
})
export class TreeModule {}
